import { render, staticRenderFns } from "./ozon-a-uv-index.vue?vue&type=template&id=0c24a82a&"
import script from "./ozon-a-uv-index.vue?vue&type=script&lang=js&"
export * from "./ozon-a-uv-index.vue?vue&type=script&lang=js&"
import style0 from "./ozon-a-uv-index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports